let province = [{ label: "北京市", name: "北京市" },
{ label: "天津市", name: "天津市" },
{ label: "河北省", name: "河北省" },
{ label: "山西省", name: "山西省" },
{ label: "内蒙古自治区", name: "内蒙古自治区" },
{ label: "辽宁省", name: "辽宁省" },
{ label: "吉林省", name: "吉林省" },
{ label: "黑龙江省", name: "黑龙江省" },
{ label: "上海市", name: "上海市" },
{ label: "江苏省", name: "江苏省" },
{ label: "浙江省", name: "浙江省" },
{ label: "安徽省", name: "安徽省" },
{ label: "福建省", name: "福建省" },
{ label: "江西省", name: "江西省" },
{ label: "山东省", name: "山东省" },
{ label: "河南省", name: "河南省" },
{ label: "湖北省", name: "湖北省" },
{ label: "湖南省", name: "湖南省" },
{ label: "广东省", name: "广东省" },
{ label: "广西壮族自治区", name: "广西壮族自治区" },
{ label: "海南省", name: "海南省" },
{ label: "重庆市", name: "重庆市" },
{ label: "四川省", name: "四川省" },
{ label: "贵州省", name: "贵州省" },
{ label: "云南省", name: "云南省" },
{ label: "西藏自治区", name: "西藏自治区" },
{ label: "陕西省", name: "陕西省" },
{ label: "甘肃省", name: "甘肃省" },
{ label: "青海省", name: "青海省" },
{ label: "宁夏回族自治区", name: "宁夏回族自治区" },
{ label: "新疆维吾尔自治区", name: "新疆维吾尔自治区" },
{ label: "台湾省", name: "台湾省" },
{ label: "香港特别行政区", name: "香港特别行政区" },
{ label: "澳门特别行政区", name: "澳门特别行政区" }]
export default province;